/*
Defines a jspsych object for playing an audio file with no html content, this is played during main trials after a response is given.
*/

/* eslint-disable import/no-cycle */
import jsPsychAudioKeyboardResponse from "@jspsych/plugin-audio-keyboard-response"; //plays audio files and records responses from keyboard
import { mediaAssets } from "../../.."; //media files

//jspsych object for playing audio
export const audioResponse = {
  type: jsPsychAudioKeyboardResponse,
  stimulus: () => {
    return mediaAssets.audio.neutralSoundCut;
  },
  choices: "NO_KEYS",
  trial_ends_after_audio: true,
  prompt: "",
};
